import { Link } from 'react-router-dom';
import logoUrl from '../../assets/mokaleng-lms-logo.svg';

type LogoVariant = 'dark' | 'light';
type LogoSize = 'sm' | 'md' | 'lg';

interface LogoProps {
  /** `dark` for light backgrounds, `light` for dark backgrounds. */
  variant?: LogoVariant;
  size?: LogoSize;
  /** Render as a plain image rather than a link. */
  asLink?: boolean;
  className?: string;
}

const sizes: Record<LogoSize, string> = {
  sm: 'h-6 sm:h-7',
  md: 'h-7 sm:h-9',
  lg: 'h-10 sm:h-12',
};

export default function Logo({
  variant = 'dark',
  size = 'md',
  asLink = true,
  className = '',
}: LogoProps) {
  const image = (
    <img
      src={logoUrl}
      alt="Mokaleng LMS"
      className={`${sizes[size]} w-auto`}
      width={330}
      height={54}
    />
  );

  /**
   * The logo artwork contains light and mid-grey elements that lose contrast
   * on the dark footer, so the light variant sits on a white chip.
   */
  const content =
    variant === 'light' ? (
      <span className="inline-flex items-center rounded-xl bg-white px-3 py-2">
        {image}
      </span>
    ) : (
      image
    );

  if (!asLink) {
    return <span className={`inline-flex items-center ${className}`}>{content}</span>;
  }

  return (
    <Link
      to="/"
      aria-label="Mokaleng LMS home"
      className={`inline-flex items-center ${className}`}
    >
      {content}
    </Link>
  );
}
